module.exports = __webpack_public_path__ + "images/01ae625658623969a7cc250b960c4cf7.png";